import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation} from '@angular/core';

import {VehicleControlIndicator} from '../../../commons/models/domain/VehicleControlIndicator';
import {Vehicle} from '../../../commons/models/domain/Vehicle';
import {IconService} from '@commons/services/icon/icon.service';
import {Driver} from '../../../commons/models/domain/Driver';
import {MappingService} from '../../../commons/services/mapping/mapping.service';
import {Consts} from '../../../commons/consts/consts';

@Component({
    selector: 'tk-vehicle-control-indicator-value',
    styleUrls: ['./vehicle-control-indicator-value.component.less'],
    templateUrl: './vehicle-control-indicator-value.component.html',
    encapsulation: ViewEncapsulation.None
})
export class VehicleControlIndicatorValueComponent implements OnInit, OnChanges {
    @Input()
    public param?: VehicleControlIndicator;
    @Input()
    public vehicle?: Vehicle;
    @Input()
    public driver?: Driver;
    @Input()
    public group?: number;
    @Input()
    public params?: VehicleControlIndicator[];
    @Input()
    public options: any;
    @Input()
    public category: any;
    @Input()
    public tacho: any;
    @Input()
    public fuel?: VehicleControlIndicator;

    /**
     * wartosc opracowana w kompenencie
     */
    public value: any;
    public label?: string;

    public indicatorsTitle?: string;
    public indicatorsList: any[] = [];

    /**
     * ladowanie
     */
    public isLoading = true;

    constructor(private $icon: IconService) { }

    ngOnInit() {
        // na podstawie dostepnych parametrow nalezy opacowac co i jak pokazac = standaryzacja
        this.formatData();
    }

    ngOnChanges(changes: SimpleChanges) {
        // gdy nastapila zmiana wartosc to takze przetwazamy
        this.formatData();
    }

    /**
     * przygotowanie danych bo nie wszystko powinno sie wykonaywac w template
     */
    private formatData() {

        this.value = null;
        this.isLoading = true;


        // { Type: 1, Name: 'Adres' },
        // { Type: 3, Name: 'Czujniki' },
        // { Type: 4, Name: 'Kierowca' },
        // { Type: 5, Name: 'Licznik km' },
        // { Type: 6, Name: 'Napięcie' },
        // { Type: 7, Name: 'Obroty' },
        // { Type: 8, Name: 'Paliwo' },
        // { Type: 9, Name: 'Paliwo CAN' },
        // { Type: 10, Name: 'Pedał gazu' },
        // { Type: 11, Name: 'Pojazd' },
        // { Type: 14, Name: 'Sygnał GPS' },
        // { Type: 15, Name: 'Sygnał GSM' },
        // { Type: 16, Name: 'Tachograf' },
        // { Type: 17, Name: 'Temperatura' },
        // { Type: 18, Name: 'Zuzycie CAN' },

        if (this.fuel) {
            this.value = this.fuel.LV;
            this.value.Type = this.fuel.Tp;

        } else if ((this.params || this.vehicle) && this.group) {

            let value = (this.params || []).filter(o => o && o.Group === this.group);

            let cValue = (value && value.length > 0 && value[0].LV) ? value[0].LV : null;
            const cType = (value && value.length > 0 && value[0].Tp) ? value[0].Tp : null;
            this.label = (value && value.length > 0 && value[0].Nm) ? value[0].Nm : undefined;

            if (this.group === 2) {
                // pobieramy ze statusu
                value = (this.params || []).filter(o => o && o.Group === 13);
                cValue = (value && value.length > 0 && value[0].LV) ?
                    value[0].LV : null;

                // { Type: 2, Name: 'Czas' },
                if (cValue && cValue.T) {
                    const today = new Date();
                    const theDay = new Date(cValue.T);
                    const diffMs = (today.getTime() - theDay.getTime());
                    const diffMins = Math.ceil(diffMs / 1000);
                    this.value = diffMins;
                }
            } else if (this.group === 13) {
                // { Type: 13, Name: 'Status' },
                if (this.vehicle) {
                    this.value = this.$icon.getIconStatusUrlForVehicle(this.vehicle);
                }
            } else if (this.group === 3) {
                this.value = '--';
                this.getBinaryIndicators(this.params!);
            } else if (this.group === 19) {
                //status eToll
                if (this.vehicle) {
                    this.value = this.$icon.getETollStatusIconForVehicle(this.vehicle);
                } else if (this.params && cValue) {
                    this.value = this.$icon.getETollStatusIconForStatus(cValue.V);
                }
            }
            else if (this.group === 16) {
                // tacho
                // na razie nie ma danych wiec generujemy random

                const values = {
                    'driving': 0,
                    'working': 0,
                    'resting': 0,
                    'free': 0
                };
                const keys = Object.keys(values);
                let actual = 'free';


                if (this.tacho) {
                    const s = this.tacho.S1 || this.tacho.S2;
                    if (s) {
                        const state = MappingService.convertTachoStatus(s.St);

                        values.driving = (s.DD || 0) / 60;
                        values.working = (s.DW || 0) / 60;
                        values.resting = (s.DR || 0) / 60;
                        values.free = (s.DRd || 0) / 60;

                        actual = keys[state];
                    }
                }


                if (this.category) {
                    this.value = { s: (actual === this.category), v: (values as any)[this.category], t: this.category, title: this.getTitleForTachoKey(this.category) };
                } else {
                    this.category = actual;
                    this.value = { s: (actual === this.category), v: (values as any)[this.category], t: this.category, title: this.getTitleForTachoKey(this.category) };
                }

            } else {
                if (cValue) {
                    this.value = cValue;
                    this.value.Type = cType;
                }
            }

        } else if (this.driver) {
            // przygotowanie kierowcy
            this.value = this.driver;

        } else if (this.param) {

        }

        this.isLoading = false;
    }



    /**
     * pobranie binarnych czujnikow
     */

    getBinaryIndicators(params: VehicleControlIndicator[]): any[] {
        const list = [];
        this.indicatorsTitle = '';
        if (params && params.length > 0) {
            for (const param of params) {
                if (param) {
                    if (Consts.binaryIndicators.indexOf(param.Tp) !== -1 && param.LV) {
                        const p = {
                            Name: param.Nm,
                            Status: param.LV.V
                        };

                        // czy dodac
                        let flag = true;

                        // filtrowanie po stanie
                        if (this.options && this.options.indicatorStatus) {
                            if ((this.options.indicatorStatus === 'on') && flag) {
                                if (p.Status === true) {
                                    flag = true;
                                } else {
                                    flag = false;
                                }
                            }
                            if ((this.options.indicatorStatus === 'off') && flag) {
                                if (p.Status !== true) {
                                    flag = true;
                                } else {
                                    flag = false;
                                }
                            }
                        }

                        // filtorwanie po nazwie
                        if (this.options && this.options.indicatorValue) {
                            if ((this.options.indicatorValue === p.Name) && flag) {
                                flag = true;
                            } else {
                                flag = false;
                            }
                        }

                        // dodanie
                        if (flag === true) {
                            list.push(p);
                        }
                    }
                }
            }
        }

        list.sort((a, b) => a.Name.localeCompare(b.Name));

        for (let i = 0; i < list.length; i++) {
            if (i > 0) {
                this.indicatorsTitle += ', ';
            }
            this.indicatorsTitle += list[i].Name;
        }
        this.indicatorsList = list;
        return list;
    }

    private getTitleForTachoKey(key: string): string {
        switch (key) {
            case 'driving': return 'Jazda';
            case 'working': return 'Praca';
            case 'resting': return 'Odpoczynek';
            case 'free': return 'Dyspozycja';
            default: return '';
        }
    }
}
